<div class="container">
    <dxo-card style="width:100%">
        <card-body>
            <div class="data-containter">
                <img src="/assets/images/no-content.png" alt="PDF file not loading." class="img-no-content" />
                <div>
                    <div class="label-header">{{messageHeader}}</div>
                    <p class="info">
                        {{messageBody}}
                    </p>
                </div>
            </div>
        </card-body>
    </dxo-card>
</div>